<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{this.params.title}}</div>
    <div slot="body">
      <a-form :form="form.fc" v-bind="formItemLayout">
        <a-form-item label="日期">
          <a-date-picker v-decorator="decorators.record_at" />
        </a-form-item>
        <a-form-item label="GITHUB Stars">
          <a-input-number :min="0" v-decorator="decorators.github_stars" />
        </a-form-item>
        <a-form-item label="微信1群">
          <a-input-number :min="0" v-decorator="decorators.group_users1" />
        </a-form-item>
        <a-form-item label="微信2群">
          <a-input-number :min="0" v-decorator="decorators.group_users2" />
        </a-form-item>
        <a-form-item label="微信3群">
          <a-input-number :min="0" v-decorator="decorators.group_users3" />
        </a-form-item>
        <a-form-item label="微信4群">
          <a-input-number :min="0" v-decorator="decorators.group_users4" />
        </a-form-item>
        <a-form-item label="公众号">
          <a-input-number :min="0" v-decorator="decorators.wechat_followers" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'OperationRecordCreateDialog',
  mixins: [WindowsMixin, DialogMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'userInfo', 'l3PermissionEnable']),
    decorators () {
      return {
        record_at: [
          'record_at',
          {
            rules: [
              { required: true, message: this.$t('storage.text_56') },
            ],
          },
        ],
        github_stars: [
          'github_stars',
          {
            rules: [
              { required: false, message: this.$t('storage.text_56') },
            ],
          },
        ],
        group_users1: [
          'group_users1',
          {
            rules: [
              { required: true, message: this.$t('storage.text_56') },
            ],
          },
        ],
        group_users2: [
          'group_users2',
          {
            rules: [
              { required: true, message: this.$t('storage.text_56') },
            ],
          },
        ],
        group_users3: [
          'group_users3',
          {
            rules: [
              { required: true, message: this.$t('storage.text_56') },
            ],
          },
        ],
        group_users4: [
          'group_users4',
          {
            rules: [
              { required: true, message: this.$t('storage.text_56') },
            ],
          },
        ],
        wechat_followers: [
          'wechat_followers',
          {
            rules: [
              { required: false, message: this.$t('storage.text_56') },
            ],
          },
        ],
      }
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      const manager = new this.$Manager('operation_records')
      try {
        const values = await this.form.fc.validateFields(Object.keys(this.decorators))
        const data = {}
        data.group_users = [values.group_users1, values.group_users2, values.group_users3, values.group_users4]
        data.record_at = values.record_at.format('YYYY-MM-DD')
        if (values.github_stars) {
          data.github_stars = values.github_stars
        }
        if (values.wechat_followers) {
          data.wechat_followers = values.wechat_followers
        }
        await manager.create({ data })
        this.cancelDialog()
        this.params.refresh && this.params.refresh()
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
